import ScrollSpy from 'bootstrap/js/dist/scrollspy';
import $ from 'jquery';
import Josh from 'joshjs'; // trigger animate.css on scroll
import Swiper, { Autoplay, Navigation, Pagination } from 'swiper'; // Slider
import Masonry from 'masonry-layout';

import jQueryBridget from 'jquery-bridget';
jQueryBridget('masonry', Masonry, $);

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

//gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
gsap.registerPlugin(ScrollTrigger);

import '../Scss/app.scss';
import 'animate.css/animate.css';

window.ir1 = {};

// ---------------------------------------------------------------------
//  Initialize (on resize)
// ---------------------------------------------------------------------
function ir1OnResize() {

  window.ir1.device = 'desktop';
  if(window.innerWidth <= 1025) {
    window.ir1.device = 'tablet';
  }
  if(window.innerWidth <= 576) {
    window.ir1.device = 'mobile';
  }

}

$(document).ready(function () {

  window.ir1.device = 'desktop';
  if(window.innerWidth <= 1025) {
    window.ir1.device = 'tablet';
  }
  if(window.innerWidth <= 576) {
    window.ir1.device = 'mobile';
  }

  const menuOverlay = $('#menuoverlay');

  // ------------------------------------------------------------
  // Josh js Animations
  // ------------------------------------------------------------
  const joshExists = document.querySelector('.josh-js');
  if (joshExists) {
    new Josh({
      initClass: "josh-js",
      animClass: "animate__animated",
      offset: 0.2,
      animateInMobile: true,
      onDOMChange: false,
    });
  }

  // ------------------------------------------------------------
  // Menu
  // ------------------------------------------------------------
  // open
  $('.js-open-menu').on('click', function (e) {
    e.preventDefault()
    menuOverlay.addClass('open')
  })
  // close
  $('.js-close-menu').on('click', function (e) {
    e.preventDefault()
    menuOverlay.removeClass('open')
  })

  // ------------------------------------------------------------
  // Menu
  // ------------------------------------------------------------
  // open
  $('.js-open-modal').on('click', function (e) {
    e.preventDefault()
    $('.ir1-modal').addClass('show')
  })
  // close
  $('.js-close-modal').on('click', function (e) {
    e.preventDefault()
    $('.ir1-modal').removeClass('show')
  })
  $('.js-open-modal2').on('click', function (e) {
    e.preventDefault()
    const target = $(this).data('target');
    if (target) {
      $('.ir1-modal2-target.' + target).addClass('show')
    }
    $('.ir1-modal2').addClass('show')
  })
  // close
  $('.js-close-modal2').on('click', function (e) {
    e.preventDefault()
    $('.ir1-modal2').removeClass('show')
    $('.ir1-modal2-target.show').removeClass('show')
  })

  // ------------------------------------------------------------
  // Scroll to
  // ------------------------------------------------------------
  $('.js-scroll-to').on('click', function (e) {
    e.preventDefault()
    const target = $($(this).data('target'))
    let pos = target.offset().top
    if($(this).data('target') === '#home_zahlen') {
      if(window.ir1.device === 'desktop'){
        pos -= 200;
      }
      if(window.ir1.device === 'tablet'){
        pos -= 50;
      }
    }
    $('html, body').scrollTop(pos);
  })

  // ------------------------------------------------------------
  // ScrollTriggers for Parallax Icons
  // ------------------------------------------------------------
  const scrollTriggers1Exists = document.querySelector('.scroll-trigger.scroll-trigger-icon-slow');
  const scrollTriggers2Exists = document.querySelector('.scroll-trigger.scroll-trigger-icon-fast');
  const scrollTriggers3Exists = document.querySelector('.scroll-trigger.scroll-trigger-icon-faster');
  const scrollTriggers4Exists = document.querySelector('.scroll-trigger.scroll-trigger-bubble');
  if (scrollTriggers1Exists) {
    gsap.to(".scroll-trigger.scroll-trigger-icon-slow", {
      y: "-50%",
      scrollTrigger: {
        start: "top top",
        end: "+=50%",
        scrub: true
      }
    })
  }
  if (scrollTriggers2Exists) {
    gsap.to(".scroll-trigger.scroll-trigger-icon-fast", {
      y: "-100%",
      scrollTrigger: {
        start: "top top",
        end: "+=50%",
        scrub: true
      }
    })
  }
  if (scrollTriggers3Exists) {
    gsap.to(".scroll-trigger.scroll-trigger-icon-faster", {
      y: "-180%",
      scrollTrigger: {
        start: "top top",
        end: "+=50%",
        scrub: true
      }
    })
  }
  if (scrollTriggers4Exists) {
    gsap.from(".scroll-trigger.scroll-trigger-bubble", {
      y: "15rem",
      scrollTrigger: {
        trigger: ".scroll-trigger-bubble",
        scrub: true
      }
    })
  }

  // ------------------------------------------------------------
  // Home - Scroll Animations
  // ------------------------------------------------------------
  const videoZoomExists = document.querySelector('#home_animation');
  if (videoZoomExists) {
    gsap.from(".home-video-bg", {
      opacity: 1,
      scrollTrigger: {
        trigger: ".home-animation",
        pin: true,
        start: "top top",
        end: "+=600",
        scrub: true
      }
    })
    let vtl = gsap.timeline();
    vtl.from(".home-video-video", {
      scale: 4.2,
      scrollTrigger: {
        trigger: ".home-animation",
        pin: true,
        start: "top top",
        end: "+=600",
        scrub: true,
        onLeaveBack: self => {
          $('.home-video-arrow').removeClass('fadeOut')
        },
        onEnter: self => {
          $('.home-video-arrow').addClass('fadeOut')
        },
      }
    })
    let aniStart = "-=100%";
    if(window.ir1.device === 'tablet'){
      aniStart = "-=50%";
    }
    if(window.ir1.device === 'mobile'){
      aniStart = "-=20%";
    }
    console.log('device', window.ir1.device)
    console.log('aniStart', aniStart)

    vtl.from(".home-zahlen", {
      opacity: 0,
      y: "+100px",
      scrollTrigger: {
        trigger: ".home-zahlen",
        pin: false,
        start: aniStart,
        end: "top top",
        scrub: true,
        onLeaveBack: self => {
          // reset number counters if scroll back above video
          $('.numbers-count > span').each(function () {
            $(this).text(0)
          });
        },
        onEnter: self => {
          // start numbers animation when this animation is finished
          // if(!window.ir1.counter) {
          setTimeout(function () {
            $('.numbers-count > span').each(function () {
              let me = $(this);
              $({ Counter: 0 }).animate({ Counter: parseInt(me.data('num')) }, {
                duration: 1000,
                easing: 'swing',
                step: function () {
                  me.text(Math.ceil(this.Counter));
                }
              });
            });
          }, 1000);
          window.ir1.counter = true;
          // }
        }
      }
    })
    gsap.to(".home-icon.home-icon1", {
      y: "-250%",
      scrollTrigger: {
        trigger: ".home-animation",
        // pin: true,
        start: "top top",
        end: "+=1200",
        scrub: true
      }
    })
    gsap.to(".home-icon.home-icon2", {
      y: "-250%",
      scrollTrigger: {
        trigger: ".home-animation",
        // pin: true,
        start: "top top",
        end: "+=1200",
        scrub: true
      }
    })
    gsap.to(".home-icon.home-icon3", {
      y: "-300%",
      scrollTrigger: {
        trigger: ".home-animation",
        // pin: true,
        start: "top top",
        end: "+=1200",
        scrub: true
      }
    })
    gsap.to(".home-marquee span", {
      x: "-50%",
      yoyo: true,
      yoyoEase: "none",
      ease: "none",
      repeat: -1,
      duration: 12
      // scrollTrigger: {
      //   trigger: ".home-animation",
      //   pin: true,
      //   start: "top top",
      //   end: "+=600",
      //   scrub: true,
      // }
    })
  }

  // ------------------------------------------------------------
  // Home - Intro Text slider
  // ------------------------------------------------------------
  const homeIntroExists = document.querySelector('.home-intro');
  if (homeIntroExists) {
    let i = 0;
    const quotes = [
      "PRECISE",
      "CREATIVE",
      "BOLD",
      "SMART",
      "DIGITAL",
      "INNOVATIVE",
      "RELIABLE",
      "NICE",
      "IR-ONE",
    ];

    setTimeout(function () {
      let textslide = $(".intro-textslide")
      setInterval(function () {
        textslide.html(quotes[i]);
        if (i === quotes.length) {
          textslide.addClass('finished');
        } else {
          i++;
        }
      }, 200);
    }, 2000);
  }

  // ------------------------------------------------------------
  // Home - client logo slider
  // ------------------------------------------------------------
  const clientslidesExists = document.querySelector('.clientslides');
  if (clientslidesExists) {
    let tl = gsap.timeline({
      repeat: -1
    });
    tl.to(".clientslides-wrapper", {
      opacity: 1, duration: 0.5
    })
    tl.to(".clientslides-wrapper", {
      x: "-200%",
      ease: "none",
      duration: 15
    })
    tl.to(".clientslides-wrapper", {
      opacity: 0, duration: 0.5
    })
  }

  // ------------------------------------------------------------
  // Referenzen - Zitat slider
  // ------------------------------------------------------------
  const zitatslidesExists = document.querySelector('.zitat-slider.swiper');
  if (zitatslidesExists) {
    new Swiper('.zitat-slider.swiper', {
      modules: [Autoplay, Pagination],
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      speed: 2000,
      autoplay: {
        delay: 9000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      },
      navigation: false,
      pagination: {
        el: '.zitat-slider-dots',
        bullets: true,
      },
    });
  }

  // ------------------------------------------------------------
  // Expertise - image slider
  // ------------------------------------------------------------
  const expertiseslidesExists = document.querySelector('.expertise-slider.swiper');
  if (expertiseslidesExists) {
    new Swiper('.expertise-slider.swiper', {
      modules: [Autoplay, Pagination],
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      speed: 2000,
      autoplay: {
        delay: 1000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      },
      navigation: false,
      pagination: {
        el: '.expertise-slider-dots',
        bullets: true,
      },
    });
  }

  const expertiseslides2Exists = document.querySelector('.expertise-sliderfull.swiper');
  if (expertiseslides2Exists) {
    new Swiper('.expertise-sliderfull.swiper', {
      modules: [Autoplay, Pagination],
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      speed: 2000,
      autoplay: {
        delay: 1000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      },
      navigation: false,
      pagination: {
        el: '.expertise-sliderfull-dots',
        bullets: true,
      },
    });
  }

  // ------------------------------------------------------------
  // Home - Projects slider
  // ------------------------------------------------------------
  const projectSlides = $('.projectslide-title');
  if (projectSlides) {
    let projectSlider = null;

    // Start animation
    function startProjectSlider() {
      //console.log('startProjectSlider', projectSlides, projectSlidesAutoplay)
      if (projectSlides && projectSlides.length > 0) {
        projectSlider = setTimeout(function () {
          let current = $('.projectslide-title.act')
          let currentImage = $('.projectslide-image.image-' + current.data('image'))
          let next = current.next();
          if (next.length === 0) {
            next = $(projectSlides[0])
          }
          let nextImage = $('.projectslide-image.image-' + next.data('image'))

          current.removeClass('act')
          currentImage.removeClass('act')
          next.addClass('act')
          nextImage.addClass('act')

          startProjectSlider()
        }, 3000);
      }
    }

    startProjectSlider()

    projectSlides.on('mouseenter', function () {
      // stop autoplay
      clearTimeout(projectSlider)

      $('.projectslide-title.act').removeClass('act')
      $('.projectslide-image.act').removeClass('act')

      $(this).addClass('act')
      $('.projectslide-image.image-' + $(this).data('image')).addClass('act')
    })
    projectSlides.on('mouseleave', function () {
      // restart autoplay
      startProjectSlider()
    })
  }

  // ------------------------------------------------------------
  // Floating Nav
  // ------------------------------------------------------------
  const floatingNavExists = document.querySelector('#floating_nav');
  if (floatingNavExists) {
    //console.log('Floating Nav')
    const scrollSpy = new ScrollSpy(document.body, {
      target: '#floating_nav'
    })
  }

  // ------------------------------------------------------------
  // Video Player
  // ------------------------------------------------------------
  const videoPlayerExists = document.querySelector('.video-player');
  if (videoPlayerExists) {
    //console.log('Video Player')
    const media = document.querySelector('video.video-player-video');
    const controls = document.querySelector('.video-player-controls');
    const play = document.querySelector('.video-player-play');

    media.removeAttribute('controls');
    controls.style.visibility = 'visible';
    play.addEventListener('click', playPauseMedia);

    function playPauseMedia() {
      if (media.paused) {
        play.classList.add('active');
        media.play();
      } else {
        play.classList.remove('active');
        media.pause();
      }
    }

  }

  // ------------------------------------------------------------
  // News - Masonry
  // ------------------------------------------------------------
  const newsListExists = document.querySelector('.news-list');
  if (newsListExists) {
    let $msnry = $('.news-list').masonry({ itemSelector: '.news-list-item' });

    // $msnry.imagesLoaded().progress(function () {
      $msnry.masonry('layout');
    // });
  }

  // ------------------------------------------------------------
  // CU Diagram
  // ------------------------------------------------------------
  $('.js-show-diagram-description').on('click', function (e) {
      const cur = $('#' + $(this).data('open'));
      $('.contentunit-diagram-card').each(function() {
        $(this).removeClass('show');
      });
      cur.addClass('show');
  });
  $('.js-hide-diagram-description').on('click', function (e) {
    $('.contentunit-diagram-card').each(function() {
      $(this).removeClass('show');
    });
  });

  // ------------------------------------------------------------
  // Accordeon
  // ------------------------------------------------------------
  $('.js-toggle-accordeon-item').on('click', function (e) {
      const cur = $(this).closest('li');
      if(!cur.hasClass('open')) {
        // if I open the current item, then close all the other
        const li = cur.parent().children();
        li.each(function() {
          $(this).removeClass('open');
        })
        cur.addClass('open');
      } else {
        cur.removeClass('open');
      }

  });

})

$(window).on('scroll', function () {
  // ------------------------------------ Top To Progress
  let scrollTop = window.scrollY;
  let docHeight = document.body.offsetHeight;
  let winHeight = window.innerHeight;
  let scrollPercent = scrollTop / (docHeight - winHeight);
  //let scrollPercentRounded = Math.round(scrollPercent * 100);
  let degrees = scrollPercent * 360;
  if (scrollTop > 200) {
    $('.totop').addClass('show')
  } else {
    $('.totop').removeClass('show')
  }
  if (scrollTop > 50) {
    $('#header').addClass('scrolled')
  } else {
    $('#header').removeClass('scrolled')
  }
  document.querySelector(
    ".totop-bg"
  ).style.background = `conic-gradient(#fe4800 ${ degrees }deg, #000000 ${ degrees }deg)`;
});

// Delayed resizing
$(window).on('resize', function () {
  if (window.ir1.resized != null)
    clearTimeout(window.ir1.resized);

  window.ir1.resized = setTimeout(function () {
    ir1OnResize();
  }, 200);
})
